import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/public_api";
import { PedidoService } from "src/app/services/pedido-service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { InitProvider } from "src/app/services/init-provider";
import { Configuracoes } from "src/app/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/entities/configuracoesSite";
import { OrderClient } from "src/app/entities/orderClient";
import { Observable } from "rxjs";
import { UsuarioService } from "src/app/services/usuario-service";
import { BsLocaleService, DateFormatter } from "ngx-bootstrap/datepicker";
import { LogService } from "src/app/services/log-service";
import { Order } from "src/app/entities/order";
import { Location } from "@angular/common";
import { debounceTime, throttleTime } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { NgModel } from '@angular/forms';

declare var $: any;

@Component({
  selector: "app-page-new-order",
  templateUrl: "./page-new-order.component.html",
  styleUrls: ["./page-new-order.component.css"],
})
export class PageNewOrderComponent implements OnInit {
  SITE: ConfiguracoesSite;

  public error: Boolean = false;
  public errorMsg: String[] = [];
  public form: FormGroup;

  typingCliente: string;
  term: string = "";
  tipoSelecionado: any;
  noResult = false;
  selectedCliente: any;
  listCliente: any = [];
  listClient: any[] = [];
  tabelas: any = [];
  tabelasUsuario: any = [];
  tabelasCliente: any = [];
  tabelasFilial: any = [];
  pedidoTiposUsuario: any = [];
  clienteDetail: any = {};

  clientesUsuario: Observable<any[]>;

  filiais: any = [];
  filial_Estoque: any = [];
  errorClienteTabela = false;
  errorClienteBloqueado = false;

  private format = new DateFormatter();
  dataEntregaMinDate: Date;
  dataEntregaDaysDisable = [];
  clienteIdErp = {};
  pedidoOriginal;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private initProvider: InitProvider,
    private usuarioService: UsuarioService,
    private localeService: BsLocaleService,
    private pedidoService: PedidoService,
    private logService: LogService,
    private activeRoute: ActivatedRoute,
    public toastService: ToastrService,
    private location: Location
  ) {
    this.SITE = Configuracoes.SITE;
    this.dataEntregaMinDate = new Date();
    this.tipoSelecionado = localStorage.getItem("tipoPedidoPre") ? localStorage.getItem("tipoPedidoPre") : "0"

    if (
      this.dataEntregaMinDate.getHours() > this.SITE.dataEntregaHorarioLimite
    ) {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() +
          1 +
          this.SITE.dataEntregaCarenciaPrazo
      );
    } else {
      this.dataEntregaMinDate.setDate(
        this.dataEntregaMinDate.getDate() + this.SITE.dataEntregaCarenciaPrazo
      );
    }
    this.dataEntregaDaysDisable = JSON.parse(
      "[" + this.SITE.dataEntregaDiasDesabilitados + "]"
    );
    this.localeService.use("pt-br");

    this.clientesUsuario = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getClientes(
          {
            busca: this.typingCliente,
            id_usuario: this.initProvider.usuario.id,
          },
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });

    // this.filiais = initProvider.filiais;
    this.form = this.formBuilder.group({
      tabela: ["", Validators.required],
      pedidoTipo: ["", Validators.required],
      filialEstoque: [""],
    });
    if (this.SITE.mostraDataEntrega) {
      this.form.addControl(
        "dataEntrega",
        new FormControl("", [Validators.required])
      );
    }
    if (this.filiais.length == 1) {
      this.form.addControl(
        "filial",
        new FormControl(this.filiais[0].id, [Validators.required])
      );
      this.selecionaFilial(this.filiais[0].id);
    } else {
      this.form.addControl(
        "filial",
        new FormControl("", [Validators.required])
      );
    }

    this.pedidoOriginal = this.router.getCurrentNavigation().extras.state;

    if (this.pedidoOriginal) {
      for (let cliente_ in this.pedidoOriginal.clientes) {
        this.selecionaCliente(this.pedidoOriginal.clientes[cliente_].cliente);
        $("#cliente").val("");
      }

      this.form.controls["tabela"].setValue(this.pedidoOriginal.tabela.id);
      this.form.controls["pedidoTipo"].setValue(this.pedidoOriginal.tipo.id);

      if (
        this.pedidoOriginal.dataEntrega &&
        this.pedidoOriginal.dataEntrega != null
      )
        this.form.controls["dataEntrega"].setValue(
          this.pedidoOriginal.dataEntrega
        );
    }
  }

  onInput(e) {
    this.term = e.target.value;

    this.usuarioService.getClientes(
      { busca: this.term, id_usuario: this.initProvider.usuario.id },
      function (resp) {
        this.listClient = resp;
      }
    );
  }
  select(param){
    this.clienteIdErp[this.selectedCliente.id] = param
  }
  onSubmit() {
    // if(this.errorClienteBloqueado){
    //   let msg = "Cliente com pendencia financeira"
    //   this.toastService.warning(msg, "", {
    //     timeOut: 4000,
    //   });
    //   return
    // }
    if (this.selectedCliente.cidades.id === null) {
      let msg = "Cidade não encontrada";
      this.toastService.warning(msg, "", {
        timeOut: 4000,
      });
      return;
    }
    if (!this.listCliente.length) {
      this.error = true;
      this.errorMsg.push("Selecione um ou mais clientes!");
      return;
    }

    if (this.tabelas.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem tabela de preço!");
      this.toastService.warning("Cliente sem tabela de preço!", "Cliente", {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("tabela").value === "") {
      this.toastService.warning("Selecione uma tabela!", "Cliente", {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.filiais.length < 1) {
      // this.error = true;
      // this.errorMsg.push("Cliente sem filial!");
      this.toastService.warning("Cliente sem filial!", "Cliente", {
        positionClass: "toast-bottom-right",
      });
      // return;
    } else if (this.form.get("filial").value === "") {
      this.toastService.warning("Selecione uma filial!", "Cliente", {
        positionClass: "toast-bottom-right",
      });
    }

    if (this.form.get("pedidoTipo").value === "") {
      this.toastService.warning("Selecione uma um tipo de pedido!", "Cliente", {
        positionClass: "toast-bottom-right",
      });
    }

    // if (!this.form.valid) {
    //   this.error = true;
    //   this.errorMsg = "Confira o formulário corretamente!";
    //   return;
    // }

    if (this.clienteIdErp[this.selectedCliente.id] === "") {
      this.toastService.warning("Escolha um endereço", "Cliente", {
        positionClass: "toast-bottom-right",
      });
    }

    if (
      (this.filial_Estoque === "" || this.filial_Estoque.length === 0) &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning("Cliente sem filial de estoque", "Cliente", {
        positionClass: "toast-bottom-right",
      });
      return;
    } else if (
      this.form.get("filialEstoque").value === "" &&
      this.initProvider.usaFilialEstoque
    ) {
      this.toastService.warning("Selecione uma filial de estoque", "Cliente", {
        positionClass: "toast-bottom-right",
      });
      return;
    }

    if (
      this.form.valid &&
      !this.pedidoService.loading &&
      this.clienteIdErp[this.selectedCliente.id] !== ""
    ) {
      let filialId = this.form.get("filial").value;
      let tabelaId = this.form.get("tabela").value;
      let pedidoTipoId = this.form.get("pedidoTipo").value;
      let filialEstoqueId = this.form.get("filialEstoque").value;
      let pedidoClientes: OrderClient[] = [];
      let dataEntrega = "";
      if (this.SITE.mostraDataEntrega) {
        dataEntrega = this.format.format(
          this.form.get("dataEntrega").value,
          "DD/MM/YYYY",
          "en"
        );
      }
      this.listCliente.forEach((c) => {
        pedidoClientes.push({
          idEnderecoErp: this.clienteIdErp[c.id],
          cliente: c.id,
          quantidade: 0,
          subtotal: 0,
          impostos: 0,
          acrescimo: 0,
          acrescimoPercent: 0,
          desconto: 0,
          descontoPercent: 0,
          total: 0,
        });
      });
      let formPedido = {
        clientes: pedidoClientes,
        filial: filialId,
        tabela: tabelaId,
        tipo: pedidoTipoId,
        dataEntrega: dataEntrega,
        filialEstoque: this.initProvider.usaFilialEstoque
          ? filialEstoqueId
          : null,
      };

      this.pedidoService.abrir(
        formPedido,
        function (resp) {
          this.pedidoService.select(resp);
          Swal.fire("Pedido", "Aberto com sucesso!", "success");

          if (
            this.pedido !== undefined &&
            Configuracoes.modoVisualizacaoCatalogo
          )
            window.localStorage.setItem(
              "visualizacaoModo",
              Configuracoes.modoVisualizacaoCatalogo
            );

          this.router.navigate(["/catalogo"]);
          // this.logService.orderCreated(resp.id);
        }.bind(this),
        function (error) {
          if (error.status == 403) {
            //403 Forbidden
            let msg = "Usuário não autenticado"
            this.toastService.info(msg, "", {
              timeOut: 4000,
            });
            window.location.href = "/login";
          }
          let obj = JSON.parse(error._body);
          console.log({error: obj.detail})
          if (obj && obj.msg) {
            this.error = true;
            this.errorMsg = obj.msg;
          } 
          if (obj && obj.detail) {
            this.error = true;
            this.errorMsg = [obj.detail];
          } 
        }.bind(this)
      );
    }
  }

  onSelect(event: TypeaheadMatch): void {
    this.selecionaCliente(event.item);
  }

  selecionaCliente(cliente: any) {
    this.errorClienteTabela = false;
    this.errorClienteBloqueado = false;
    if (cliente.bloqueiaPedidos) {
      this.errorClienteBloqueado = true;
    }

    this.clienteIdErp[cliente.id] = cliente.idEnderecoErp
      ? cliente.idEnderecoErp + ""
      : "";

    // if (this.listCliente.length > 0) {
    //   let comp1 = "";
    //   let comp2 = "";
    //   cliente.tabelas.forEach((t) => {
    //     comp1 += t.id;
    //   });
    //   this.listCliente[this.listCliente.length - 1].tabelas.forEach((t) => {
    //     comp2 += t.id;
    //   });
    //   if (comp1 != comp2) {
    //     this.errorClienteTabela = true;
    //     this.setSelectedCliente(cliente);
    //     $("#cliente").val("");
    //     return;
    //   }
    // }

    // this.usuarioService.getPedidoTipos(
    //   function (resp) {
    //     this.pedidoTiposUsuario = resp;
    //     if (this.pedidoTiposUsuario.length == 1) {
    //       this.form.controls.pedidoTipo.setValue(
    //         this.pedidoTiposUsuario[0].id
    //       );
    //     }
    //   }.bind(this)
    // );
    // this.usuarioService.getFiliais(cliente.filial_cliente, (e) => this.filiais = e);
    // this.usuarioService.getTabelas(cliente.id, e => this.tabelas = e)
    // function (resp) {
    //   this.tabelasUsuario = resp;
    //   this.usuarioService.getPedidoTipos(
    //     function (resp) {
    //       this.pedidoTiposUsuario = resp;
    //       if (this.pedidoTiposUsuario.length == 1) {
    //         this.form.controls.pedidoTipo.setValue(
    //           this.pedidoTiposUsuario[0].id
    //         );
    //       }
    //     }.bind(this)
    //   );
    // }.bind(this)
    // );

    this.usuarioService.getClientesId(
      {
        id_cliente: cliente.id,
        id_usuario: this.initProvider.usuario.id,
      },
      (resp) => {
        // if (resp.cidades.id === null) {
        //   let msg = "Cidade não encontrada"
        //   this.toastService.warning(msg, "", {
        //     timeOut: 4000,
        //   });
        //   return
        // }

        this.usuarioService.getPedidoTipos(
          function (resp) {
            this.pedidoTiposUsuario = resp;
            if (this.pedidoTiposUsuario.length == 1) {
              this.form.controls.pedidoTipo.setValue(
                this.pedidoTiposUsuario[0].id
              );
            }
          }.bind(this)
        );
        // this.tabelasCliente = resp[0].fn_cliente_id.content[0].tabela_preco.filter((f) => f.ativo);
        this.filiais = resp.filiais;
        this.tabelas = resp.tabela_preco;
        this.filial_Estoque = resp.filial_estoque;
        this.setSelectedCliente(resp);
        this.addCliente(resp);

        if (resp.filiais[0]) {
          this.form.controls.filial.setValue(
            resp.filiais[0].id
          );
        }
        if (resp.tabela_preco[0]) {
          this.form.controls.tabela.setValue(
            resp.tabela_preco[0].id
          );
        }
        if (resp.filial_estoque[0]) {
          this.form.controls.filialEstoque.setValue(
            resp.filial_estoque[0].id
          );
        }
      }
    );
    this.openTabelas();
    $("#cliente").val("");
  }

  setSelectedCliente(c: any) {
    if (c.enderecos.length === 1) {
      this.clienteIdErp[c.id] = c.enderecos[0].id;
    }
    this.selectedCliente = c;
  }

  excluiCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) {
        this.listCliente.splice(i, 1);
        break;
      }
    }
    if (this.selectedCliente && this.selectedCliente.id == c.id) {
      if (this.listCliente.length) {
        this.selectedCliente = this.listCliente[this.listCliente.length - 1];
      } else {
        this.tabelasCliente = [];
        this.selectedCliente = null;
        this.openTabelas();
      }
    }
    this.filiais = [];
    this.tabelasFilial = [];
  }

  addCliente(c: any) {
    for (var i = 0; i < this.listCliente.length; i++) {
      if (this.listCliente[i].id == c.id) return;
    }
    this.listCliente.push(c);
  }
  selectTipo(e) {
    console.log(e.target.value);
    localStorage.setItem("tipoPedidoPre", e.target.value);
  }
  selecionaFilial(idFilial) {
    let filial: any;
    for (var i = 0; i < this.filiais.length; i++) {
      if (this.filiais[i].id == idFilial) {
        filial = this.filiais[i];
      }
    }
    if (!filial) return;

    this.tabelasFilial = filial.tabelas.filter((f) => f.ativo);
    this.openTabelas();
  }

  openTabelas() {
    this.form.controls.tabela.setValue("");
    if (this.tabelasFilial.length) {
      this.tabelas = this.tabelasFilial;
    } else if (this.tabelasCliente.length) {
      this.tabelas = this.tabelasCliente;
    } else {
      this.tabelas = this.tabelasUsuario;
    }
    if (this.tabelas.length > 0) {
      this.form.controls.tabela.setValue(this.tabelas[0].id);
    }
  }

  typeaheadNoResults(event: boolean): void {
    this.noResult = event;
  }

  ngOnInit() {
    if (!this.pedidoService.confirmaAbandonarPedidoEmAberto()) {
      this.location.back();
    }
  }
}
